import {Component, OnInit, ViewChild} from '@angular/core';
import {Router} from '@angular/router';
import {ExportType, InvoiceProcessingService} from '../../../../core/services/invoice-processing.service';
import {Hierarchy} from '@model/Hierarchy';
import {OIExpInvCurrent} from '@model/OIExpInvCurrent';
import {DialogType, FSInvoiceDialogService} from '~/app/core/services/fsinvoice.dialog.service';
import {UserService} from '~/app/core/services/user.service';
import {LocalStorageIndexedService} from '~/app/web/AppProvider/LocalStorageIndexedService';
import {AppEnums} from '~/app/web/AppProvider/AppEnums';
import {ChainInvoice} from '@model/ChainInvoice';
import {LoadingIndicator} from "mclane-apptemplate-lib";
import {ExportDialogComponent} from '~/app/web/export-dialog/export-dialog.component';
import {ExportDate} from '@model/ExportDate';
import {DatePipe} from '@angular/common';
import {DataBindingDirective, DataStateChangeEvent, SelectAllCheckboxState} from '@progress/kendo-angular-grid';
import {paths} from '~/app/app-paths';

import {CompositeFilterDescriptor, filterBy, process} from '@progress/kendo-data-query';
import { LoadingIndicatorHelper } from '~/app/core/services/loading-indicator-helper';

@Component({
  selector: 'app-invoice-processing',
  templateUrl: './invoice-processing.component.html',
  styleUrls: ['./invoice-processing.component.scss']
})
export class InvoiceProcessingComponent implements OnInit {
  @ViewChild(DataBindingDirective) dataBinding: DataBindingDirective;
  // @ViewChild ('tabs', {static: false}) tabGroup: MatTabGroup;
  typeList: string[] = [];
  selectedHierarchy: Hierarchy;
  selectedType: string;

  public gridData: any = [];
  public gridView: any = [];


  public mySelection: OIExpInvCurrent[] = [];
  public hierarchyList: Hierarchy[] = [];
  public invoiceList: OIExpInvCurrent[] = [];
  public invoiceListCurrent: OIExpInvCurrent[] = [];
  public invoiceListArchive: OIExpInvCurrent[] = [];
  public chnInvList: ChainInvoice[] = [];
  public state: any = {
    skip: 0,
    take: 20,

    // Initial filter descriptor
    filter: {
      // logic: 'and',
      // filters: [   {
      //   field: 'invoiceNumber',
      //   operator: 'contains',
      //   value: inputValue
      // },
      //   {
      //     field: 'storeId',
      //     operator: 'contains',
      //     value: inputValue
      //   },
      //   {
      //     field: 'invoiceTotal',
      //     operator: 'contains',
      //     value: inputValue
      //   }]
    }
  };

  // public state: State = {
  //   skip: 0,
  //   take: 5,
  //
  //   // Initial filter descriptor
  //   filter: {
  //     logic: 'and',
  //     filters: [{ field: 'ProductName', operator: 'contains', value: 'Chef' }]
  //   }
  // };


  public selectAllState: SelectAllCheckboxState = 'unchecked';

  public selectAllRecordState: SelectAllCheckboxState = 'unchecked';
  constructor(public router: Router,
              public invoiceProcessingService: InvoiceProcessingService,
              public dialogService: FSInvoiceDialogService,
              public userService: UserService,
              public localStorage: LocalStorageIndexedService,
              public datepipe: DatePipe,
              public loadingIndicator: LoadingIndicatorHelper) {

  }

  public selectedCallback = (args) => args.dataItem;
  public filter: CompositeFilterDescriptor;

  async ngOnInit() {
    this.loadingIndicator.show();
    if (this.userService.selectedHomeOffice === undefined) {
      if (this.localStorage.getFromSession(AppEnums.HOME_OFFICE) !== undefined && this.localStorage.getFromSession(AppEnums.HOME_OFFICE) !== null) {
        this.invoiceProcessingService.selectedHomeOffice = this.localStorage.getFromSession(AppEnums.HOME_OFFICE);
        await this.init().then(() => {
          this.loadingIndicator.hide();
        });
      } else {
        this.loadingIndicator.hide();
        await this.router.navigate([paths.home]);
      }
    } else {
      this.invoiceProcessingService.selectedHomeOffice = this.userService.selectedHomeOffice;
      await this.init().then(() => {
        this.loadingIndicator.hide();
      });
    }

  }

  public onSelectAllRecordChange(checkedState: SelectAllCheckboxState): void {
    if (checkedState === 'checked') {
      this.mySelection = this.gridData.filter((item) => item);
      this.gridData.total = this.mySelection.length;
      this.selectAllRecordState = 'checked';
    } else {
      this.mySelection = [];
      this.selectAllRecordState = 'unchecked';
    }
  }


  public async init() {
    this.hierarchyList = await this.invoiceProcessingService.getHierarchyList();
    if (this.hierarchyList !== undefined) {
      this.selectedHierarchy = await this.hierarchyList[0];

      this.typeList = ['Current', 'Archive'];
      if (this.selectedType === undefined) {
        this.selectedType = 'Current';
      }

      this.populateInvoiceGrid();
      await this.invoiceProcessingService.getDownloadType().then(downloadType => {
        this.invoiceProcessingService.downloadType = downloadType;
        this.invoiceProcessingService.downloadType.toString().split(',').forEach(type => {
          this.invoiceProcessingService.downloadTypes.push(type);
        });
      });
    } else {
      this.selectedHierarchy = null;
    }

  }

  async populateInvoiceGrid() {
    this.loadingIndicator.show();
    this.mySelection = [];
    await this.loadGrid();
    if (this.selectedHierarchy.key.trim() === 'CORP') {
      this.gridData = this.invoiceList;
      this.gridData.total = this.invoiceList.length;
    } else {
      this.gridData = this.invoiceList.filter(item => item.lvlParent.trim() === this.selectedHierarchy.key.trim());
      this.gridData.total = this.invoiceList.filter(item => item.lvlParent.trim() === this.selectedHierarchy.key.trim()).length;
    }
    this.gridView = this.gridData;
    this.loadingIndicator.hide();
  }

  public async loadGrid() {

    if (this.selectedType === 'Current') {
      this.invoiceListCurrent = await this.invoiceProcessingService.getInvoices('Current');
      this.invoiceListCurrent.forEach(invoice => {
        const invoiceDatePart = invoice.invoiceDate.toString().split('-');
        invoice.invoiceDate = new Date(Number(invoiceDatePart[0]), Number(invoiceDatePart[1]) - 1, Number(invoiceDatePart[2]));
        const discountDatePart = invoice.discountDate.toString().split('-');
        invoice.discountDate = new Date(Number(discountDatePart[0]), Number(discountDatePart[1]) - 1, Number(discountDatePart[2]));
      });
      this.invoiceList = this.invoiceListCurrent;
    } else {
      this.invoiceListArchive = await this.invoiceProcessingService.getInvoices('Archive');
      this.invoiceListArchive.forEach(invoice => {
        const invoiceDatePart = invoice.invoiceDate.toString().split('-');
        invoice.invoiceDate = new Date(Number(invoiceDatePart[0]), Number(invoiceDatePart[1]) - 1, Number(invoiceDatePart[2]));
        const discountDatePart = invoice.discountDate.toString().split('-');
        invoice.discountDate = new Date(Number(discountDatePart[0]), Number(discountDatePart[1]) - 1, Number(discountDatePart[2]));
      });
      this.invoiceList = this.invoiceListArchive;
    }
    return this.invoiceList;
  }

  public async filterGrid() {
    // TODO if not using doesn't work, i need to filter based on hierarch and type here
    if (this.selectedType === 'Current') {
      this.invoiceList = this.invoiceListCurrent;
    } else {
      this.invoiceList = this.invoiceListArchive;
    }
    return this.invoiceList;
  }


  async exportClicked() {
    if (this.mySelection.length > 1350) {
      this.dialogService.openDialog({
        type: DialogType.ERROR,
        title: 'Export',
        content: this.mySelection.length + ' invoices are selected. Maximum 1350 invoices can be exported at a time.',
        actions: [
          {text: 'Ok', primary: true},
        ],
        width: 400
      }).then(r => r);
    } else {
      this.loadingIndicator.show();
      this.chnInvList = [];
      // this.selectAllState = 'unchecked';
      this.invoiceProcessingService.selectedInvoices = '';
      if (this.mySelection.length > 0) {
        this.mySelection.forEach(invoice => {
          const chainInv = new ChainInvoice();
          chainInv.chain = invoice.chn;
          chainInv.invDate = this.datepipe.transform(invoice.invoiceDate, 'yyyy-MM-dd');
          chainInv.invNum = invoice.invoiceNumber;
          this.chnInvList.push(chainInv);
          // this.invoiceProcessingService.selectedInvoices += this.datepipe.transform(invoice.invoiceDate, 'yyyy-MM-dd') + '%20' + invoice.invoiceNumber + '%2C';
          this.invoiceProcessingService.selectedInvoices += this.datepipe.transform(invoice.invoiceDate, 'yyyy-MM-dd') + ' ' + invoice.invoiceNumber + ',';
        });
        this.invoiceProcessingService.chnInvList = this.chnInvList;
        this.invoiceProcessingService.selectedInvoices = this.invoiceProcessingService.selectedInvoices.slice(0, -1);
        this.invoiceProcessingService.isSegSepEnabled(this.userService.getUserName())
          .then(res => {
            this.invoiceProcessingService.isSegSep = res as string;
          })
        const count:any = await this.invoiceProcessingService.getExceptionsCount();
        if (count > 0) {
          this.mySelection = [];
          this.router.navigate([paths.itemsPosting]).then(r => r);
        } else {
          const dialogRef = this.dialogService.open({
            type: DialogType.INFO,
            title: 'Available Exports',
            content: ExportDialogComponent,
            actions: [
              {text: 'Cancel', primary: false},
              {text: 'Download', primary: true},
            ],
            width: 400
          });

          const dialogContent = dialogRef.content.instance;
          dialogRef.result.subscribe((answer: any) => {
            if (answer.text === 'Download') {
              let results = dialogContent.formGroup.value;
              Object.keys(results).forEach(key => {
                if (key === ExportType.ACCPAC && results[key] === true) {
                  this.invoiceProcessingService.showExportDownload(ExportType.ACCPAC);
                }
                if (key === ExportType.ACUITY && results[key] === true) {
                  this.invoiceProcessingService.showExportDownload(ExportType.ACUITY);
                }
                if (key === ExportType.AMERINVC && results[key] === true) {
                  this.invoiceProcessingService.showExportDownload(ExportType.AMERINVC);
                }
                if (key === ExportType.APCLARUS && results[key] === true) {
                  this.invoiceProcessingService.showExportDownload(ExportType.APCLARUS);
                }
                if (key === ExportType.APHDR4 && results[key] === true) {
                  this.invoiceProcessingService.showExportDownload(ExportType.APHDR4);
                }
                if (key === ExportType.APHDRDYN && results[key] === true) {
                  this.invoiceProcessingService.showExportDownload(ExportType.APHDRDYN);
                }
                if (key === ExportType.APSUMM4 && results[key] === true) {
                  this.invoiceProcessingService.showExportDownload(ExportType.APSUMM4);
                }
                if (key === ExportType.MASXPORT && results[key] === true) {
                  this.invoiceProcessingService.showExportDownload(ExportType.MASXPORT);
                }
                if (key === ExportType.MSISETUP && results[key] === true) {
                  this.invoiceProcessingService.showExportDownload(ExportType.MSISETUP);
                }
                if (key === ExportType.NSINV && results[key] === true) {
                  this.invoiceProcessingService.showExportDownload(ExportType.NSINV);
                }
                if (key === ExportType.QBOOKSINVC && results[key] === true) {
                  this.invoiceProcessingService.showExportDownload(ExportType.QBOOKSINVC);
                }
                if (key === ExportType.VOUCHER && results[key] === true) {
                  this.invoiceProcessingService.showExportDownload(ExportType.VOUCHER);
                }
              });

              const exportDate = new ExportDate();
              exportDate.hoId = this.invoiceProcessingService.selectedHomeOffice.hoId;
              exportDate.chnInvList = this.chnInvList;
              this.invoiceProcessingService.exportDate(exportDate)
                .subscribe(() => {
                  //this.populateInvoiceGrid();
                });
            } else {
              this.loadingIndicator.hide();
            }
          });
        }
      } else {
        this.dialogService.openDialog({
          type: DialogType.ERROR,
          title: 'Export',
          content: 'Please add at least one Invoice to export.',
          actions: [
            {text: 'Ok', primary: true},
          ],
          width: 400
        }).then(r => r);
      }
      this.loadingIndicator.hide();
    }
  }


  public async hierarchyValueChange(value: any) {
    this.loadingIndicator.show();
    this.selectAllState = 'unchecked';
    this.selectAllRecordState = 'unchecked';
    this.mySelection = [];
    this.selectedHierarchy = value;
    await this.filterGrid(); // TODO removed filter
    if (value.key.trim() === 'CORP') {
      this.gridData = this.invoiceList;
      this.gridData.total = this.invoiceList.length;
    } else {
      this.gridData = this.invoiceList.filter(item => item.lvlParent.trim() === value.key.trim());
      this.gridData.total = this.invoiceList.filter(item => item.lvlParent.trim() === value.key.trim()).length;
    }
    this.gridView = this.gridData;
    this.loadingIndicator.hide();
  }

  public async typeValueChange(value: any) {
    this.loadingIndicator.show();
    this.selectAllState = 'unchecked';
    this.selectAllRecordState = 'unchecked';
    this.mySelection = [];
    this.selectedType = value;

    if (value === 'Archive' && this.invoiceListArchive.length < 1) {
      this.invoiceListArchive = await this.invoiceProcessingService.getInvoices('Archive');
      this.invoiceListArchive.forEach(invoice => {
        const invoiceDatePart = invoice.invoiceDate.toString().split('-');
        invoice.invoiceDate = new Date(Number(invoiceDatePart[0]), Number(invoiceDatePart[1]) - 1, Number(invoiceDatePart[2]));
        const discountDatePart = invoice.discountDate.toString().split('-');
        invoice.discountDate = new Date(Number(discountDatePart[0]), Number(discountDatePart[1]) - 1, Number(discountDatePart[2]));
      });

      this.invoiceList = this.invoiceListArchive;
    }
    await this.filterGrid(); // remove filter grid

    if (this.selectedHierarchy !== null && this.selectedHierarchy !== undefined) {
      if (this.selectedHierarchy.key.trim() === 'CORP') {
        this.gridData = this.invoiceList;
        this.gridData.total = this.invoiceList.length;
      } else {
        this.gridData = this.invoiceList.filter(item => item.lvlParent.trim() === this.selectedHierarchy.key.trim());
        this.gridData.total = this.invoiceList.filter(item => item.lvlParent.trim() === this.selectedHierarchy.key.trim()).length;
      }
    }

    this.gridView = this.gridData;
    this.loadingIndicator.hide();
  }

  public onSelectAllChange(checkedState: SelectAllCheckboxState) {
    if (checkedState === 'checked') {
      if (this.selectedHierarchy.key.trim() === 'CORP') {
        this.mySelection = this.gridData.filter((item) => item);
        this.gridData.total = this.mySelection.length;
      } else {
        this.mySelection = this.gridData.filter(item => item.lvlParent.trim() === this.selectedHierarchy.key.trim());
        this.gridData.total = this.mySelection.length;
      }
      this.selectAllState = 'checked';
    } else {
      this.mySelection = [];
      this.selectAllState = 'unchecked';
    }
  }


  onFilter(inputValue: any) {
    console.log(inputValue);
    this.gridView = process(this.gridData, {
      filter: {
        logic: 'or',
        filters: [
          {
            field: 'invoiceNumber',
            operator: 'contains',
            value: inputValue
          },
          {
            field: 'storeId',
            operator: 'contains',
            value: inputValue
          },
          {
            field: 'invoiceTotal',
            operator: 'contains',
            value: inputValue
          }
        ],
      }
    }).data;


    this.dataBinding.skip = 0;
  }

  dataStateChange(state: DataStateChangeEvent) {
    this.selectAllState = 'unchecked';
    this.selectAllRecordState = 'unchecked';
    console.log('dataStateChange');
    console.warn(state);
    // this.state = state;
    // this.gridData = process(this.gridView, this.state);

  }

  public filterChange(filter: CompositeFilterDescriptor): void {
    console.log('filterChange');
    console.warn(filter);
    this.filter = filter;
    this.gridData = filterBy(this.gridView, filter);
  }
}
